import CartApi from '@apis/cart/CartApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useActivity } from '@stackflow/react';
import useCalculatedCart from '@store/cart/hooks/useCalculatedCart';
import { useQueryClient } from '@tanstack/react-query';
import { isEqual } from 'lodash';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    shopId: string;
    cartId: string;
}

function useCartQuantity({ shopId, cartId }:Props) {
    const toast = useToast();
    const { orderLines } = useCalculatedCart();
    const { isActive } = useActivity();
    const queryClient = useQueryClient();
    const { t } = useTranslation('cart');
    const initialOrderLines = useRef(orderLines);

    const handleUpdateQuantityOnLeave = () => () => {
        const isChanged = !isEqual(initialOrderLines.current, orderLines);
        if (!isActive && isChanged) {
            const updateRequests = orderLines
                .filter((orderItem) => !!orderItem.cartItemId)
                .map((orderItem) => {
                    const { cartItemId, quantity } = orderItem;
                    return CartApi.updateCartItemQuantity(shopId, cartId, cartItemId!, {
                        qty: quantity,
                    });
                });
            Promise.allSettled(updateRequests)
                .then(() => {
                    queryClient.invalidateQueries({ queryKey: queries.cart.detail._def });
                    queryClient.invalidateQueries({ queryKey: queries.cart.cartId._def });
                    initialOrderLines.current = orderLines;
                }).catch(() => {
                    toast.error(t('toast.quantityError'));
                });
        }
    };

    // 페이지에서 벗어날 때 장바구니 수량 변경
    useEffect(handleUpdateQuantityOnLeave, [isActive, orderLines, initialOrderLines]);
}

export default useCartQuantity;
